export default __webpack_public_path__ + "static/media/IchhanshuJaiswal.cac3f09d.png";